import React from 'react';

/**
 * Field Actions Component - Renders action buttons for a field (move up/down, duplicate, delete)
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const FieldActions = _ref => {
  let {
    field,
    index,
    totalFields,
    onMoveUp,
    onMoveDown,
    onDuplicate,
    onDelete
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "field-actions",
    children: [/*#__PURE__*/_jsx("button", {
      className: "action-btn move-up",
      onClick: e => {
        e.stopPropagation();
        onMoveUp(field.id);
      },
      disabled: index === 0,
      title: "Move up",
      children: "\u2191"
    }), /*#__PURE__*/_jsx("button", {
      className: "action-btn move-down",
      onClick: e => {
        e.stopPropagation();
        onMoveDown(field.id);
      },
      disabled: index === totalFields - 1,
      title: "Move down",
      children: "\u2193"
    }), /*#__PURE__*/_jsx("button", {
      className: "action-btn duplicate",
      onClick: e => {
        e.stopPropagation();
        onDuplicate(field.id);
      },
      title: "Duplicate",
      children: "\uD83D\uDCCB"
    }), /*#__PURE__*/_jsx("button", {
      className: "action-btn delete",
      onClick: e => {
        e.stopPropagation();
        onDelete(field.id);
      },
      title: "Delete",
      children: "\uD83D\uDDD1\uFE0F"
    })]
  });
};